import { IEnrollmentComponentCourseView, IEnrollmentComponentRankView } from "./types";

export function calculateRankProgress(rank: IEnrollmentComponentRankView) {
    const coursesProgress = rank.courses?.reduce(
        (acc: number, current: IEnrollmentComponentCourseView) =>
            acc + (current.enrollment?.progress ?? 0),
        0,
    );
    const courseCount = rank.courses?.length;
    if (!coursesProgress || !courseCount) {
        return 0;
    }

    return Math.floor(coursesProgress / courseCount);
}

export function isCourseCompleted(course: IEnrollmentComponentCourseView) {
    return course.enrollment?.progress === 100;
}
